module.exports = __webpack_public_path__ + "static/img/btn_gfcz.6fe487c.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/btn_gfcz.png
// module id = Ci1Z
// module chunks = 7